import { createStyles, makeStyles } from '@material-ui/core';
import { fade } from '@material-ui/core/styles/colorManipulator';

export default makeStyles((theme) =>
  createStyles({
    bubble: {
      backgroundColor: fade(
        theme.palette.success.light,
        theme.palette.action.hoverOpacity
      ),
      flexDirection: 'row-reverse',
    },
  })
);
